module.exports = __webpack_public_path__ + "img/swipe-hand.989acb47.png";